import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import { useMemo } from 'react';

// project imports
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';
import LanguageSelector from './LanguageSelector';
import MapShorCut from './MapShorCut';
import VideoMonShortCut from './VideoMonShortCut';
import SoundToggle from './SoundToggle';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { hasMap, hasVideo } = useMemo(() => {
    let map = false;
    let video = false;

    try {
      const rawMenu = localStorage.getItem('master_menu');
      if (rawMenu) {
        const parsedMenu = JSON.parse(rawMenu);

        // Recursive function to check children
        const checkModules = (items) => {
          if (!Array.isArray(items)) return;
          for (const item of items) {
            if (item.modules_name === 'maps-monitoring' || item.modules_name === 'map') map = true;
            if (item.modules_name === 'live-streaming') video = true;
            if (item.children && item.children.length > 0) {
              checkModules(item.children);
            }
          }
        };

        checkModules(parsedMenu);
      }
    } catch (e) {
      console.error('Failed to parse master_menu from localStorage', e);
    }

    return { hasMap: map, hasVideo: video };
  }, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {/* {!downLG && <Search />}
      {!downLG && megaMenu}
      {!downLG && localization}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      <Notification />
      <Message />
      {!downLG && <FullScreen />}
      {!downLG && <Profile />} */}

      <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
        {hasMap && <MapShorCut />}
        {hasVideo && <VideoMonShortCut />}
        <SoundToggle />
        <LanguageSelector />

        <Notification />
        {!downLG && <Profile />}
      </Box>
      {downLG && <MobileSection />}
    </>
  );
}
